<!--
 * @Author: Gaho
 * @Date: 2024-03-27 13:56:58
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-02 11:03:08
 * @Description: 
-->
<template>
    <div class="live-charts" id="liveCharts"></div>
</template>

<script setup lang="ts">
// import * as echarts from 'echarts';
const myCharts = shallowRef(null);
const props = defineProps({
    chartConfig: {
        type: Object,
        default: () => ({}),
    }
});

onMounted(async () => {
    await nextTick();
    if (!myCharts.value){
        const echarts = await getEcharts().catch(err=>{
            console.log('load echarts error 0', err);
        });
        myCharts.value = echarts?.init(document.getElementById('liveCharts'));
        if (!myCharts.value){
            return console.error('echarts 加载失败 onMounted()');
        }
        props.chartConfig && myCharts.value.setOption(props.chartConfig);
        window.addEventListener('resize', handleResize);
    }
});

watch(() => props.chartConfig, (newVal, oldVal) => {
    if (!myCharts.value){
        return console.error('echarts 加载失败 watch()');
    }
    myCharts.value.setOption(newVal);
}, { deep: true });

const handleResize = () => {
    console.log(myCharts.value, 'myCharts.value')
    myCharts.value.resize();
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
})
</script>

<style lang="scss" scoped>
.live-charts {
    position: relative;
    width: 236px;
    height: 146px;
    padding: 0px;
    margin: 0px;
    border-width: 0px;
    cursor: default;
}
</style>